window.ThemeCart = window.ThemeCart || {};

class ThemeCartCheckoutGuard {
  static readQuantityInputs(form, maxQuantity = null) {
    if (!form || typeof form.querySelectorAll !== "function") return {};

    const updates = {};
    form.querySelectorAll('input.cart-item__quantity[name="updates[]"][data-line-id]').forEach((input) => {
      const lineId = input.getAttribute("data-line-id");
      if (!lineId) return;

      let quantity = Math.max(parseInt(input.value, 10) || 0, 0);
      const maxAttr = input.getAttribute("max");
      const max = maxAttr != null && String(maxAttr).trim() !== "" ? parseInt(maxAttr, 10) : NaN;
      if (Number.isFinite(max) && max >= 0) quantity = Math.min(quantity, max);
      if (typeof maxQuantity === "function") {
        quantity = Math.min(quantity, maxQuantity());
      }

      input.value = String(quantity);
      updates[String(lineId)] = quantity;
    });

    return updates;
  }

  static async flushQuantityInputs(form, signal, maxQuantity = null) {
    const desiredUpdates = ThemeCartCheckoutGuard.readQuantityInputs(form, maxQuantity);
    const desiredKeys = Object.keys(desiredUpdates);
    if (!desiredKeys.length) return null;

    const currentCart = await window.ThemeCart.CartApi.fetchCart(signal);
    const currentQuantityByKey = new Map();
    const currentItems = Array.isArray(currentCart?.items) ? currentCart.items : [];
    currentItems.forEach((item) => {
      if (item?.key) currentQuantityByKey.set(String(item.key), Number(item.quantity) || 0);
    });

    const updates = {};
    desiredKeys.forEach((key) => {
      if (!currentQuantityByKey.has(key)) return;
      const desiredQuantity = desiredUpdates[key];
      if (currentQuantityByKey.get(key) !== desiredQuantity) {
        updates[key] = desiredQuantity;
      }
    });

    if (!Object.keys(updates).length) return currentCart;

    const res = await window.ThemeCart.CartApi.update({ updates }, signal);
    if (!res.ok) throw new Error(`Cart quantity flush failed: ${res.status}`);
    return res.json();
  }

  static cartHasCheckoutableLines(cartData, options = null) {
    const items = Array.isArray(cartData?.items) ? cartData.items : [];
    if (!items.length) return false;

    const giftOptions = options || {};
    const variantId = giftOptions?.freeGiftVariantId;
    const propertyKey = giftOptions?.freeGiftPropertyKey || "_free_gift";
    const propertyValue = giftOptions?.freeGiftPropertyValue || "true";
    const variantIdStr = variantId != null && variantId !== "" ? String(variantId) : "";

    return items.some((item) => {
      if (!item || (Number(item.quantity) || 0) <= 0) return false;

      const role = window.ThemeCart.CartLineRules.readBundleRole(item);
      if (role === "bundle_list_product") return false;
      if (window.ThemeCart.CartLineRules.propertyValue(item, "_bundle_slot")) return false;

      let isThemeGift = window.ThemeCart.CartLineRules.hasThemeFreeGiftMarker(item);
      if (!isThemeGift && variantIdStr) {
        isThemeGift = window.ThemeCart.FreeGiftRules.lineQualifiesAsThemeFreeGiftSlot(
          item,
          giftOptions,
          variantIdStr,
          propertyKey,
          propertyValue
        );
      }

      return !isThemeGift;
    });
  }
}

window.ThemeCart.CheckoutGuard = ThemeCartCheckoutGuard;
